export const KEY_COLUMN_ORDER_KEY_PREFIX = 'Column-order-nova-'
export const KEY_COLUMN_RESIZING_KEY_PREFIX = 'Column-sizes-nova-'
